import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const YourInfoGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr) 40px',
  gap: '32px 16px',
});
